// extracted by mini-css-extract-plugin
export default {"mealNameCell":"Yc7O_hCzDr3pvbitVQDf","mealRow":"V532cvrW6t_xC8v7WhHz","mealInfoIsOpen":"STwg2v5KesgHu_TuIqmy","mealInfoBox":"bz9p57EQaRHRgPrxSMBj"};